import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './dialog';
import { Button } from './button';
import { Card, CardContent } from './card';
import { Badge } from './badge';
import { Crown, Zap, CreditCard, ArrowRight, X } from 'lucide-react';
import VBotSubscriptionModal from './vbot-subscription-modal';
import { goToTalkToSales } from '../../constants/publicSite';

const TrialExhaustedModal = ({ 
  isOpen, 
  onClose, 
  onSubscribe, 
  onViewPricing,
  trialInfo = {},
  isLoading = false 
}) => {
  const { remainingTrials = 0, totalTrials = 10000000, usedTrials = 10000000 } = trialInfo;
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);

  return (
    <>
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center">
          <div className="mx-auto mb-4 w-16 h-16 bg-gradient-to-r from-orange-400 to-red-500 rounded-full flex items-center justify-center">
            <Zap className="w-8 h-8 text-white" />
          </div>
          <DialogTitle className="text-2xl font-bold text-gray-900">
            Trial Exhausted
          </DialogTitle>
          <p className="text-gray-600 mt-2">
            You've used all {totalTrials} free trials. Upgrade to premium to continue creating SOAP notes.
          </p>
        </DialogHeader>

        <div className="space-y-4">
          {/* Trial Usage Summary */}
          <Card className="border-orange-200 bg-orange-50">
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
                  <span className="text-sm font-medium text-orange-800">
                    Free Trials Used
                  </span>
                </div>
                <Badge variant="outline" className="border-orange-300 text-orange-700">
                  {usedTrials}/{totalTrials}
                </Badge>
              </div>
              <div className="mt-2 w-full bg-orange-200 rounded-full h-2">
                <div 
                  className="bg-orange-500 h-2 rounded-full transition-all duration-300"
                  style={{ width: '100%' }}
                ></div>
              </div>
            </CardContent>
          </Card>

          {/* Premium Benefits */}
          <div className="space-y-3">
            <h3 className="font-semibold text-gray-900 flex items-center">
              <Crown className="w-5 h-5 text-yellow-500 mr-2" />
              Premium Benefits
            </h3>
            <div className="space-y-2 text-sm text-gray-600">
              <div className="flex items-center">
                <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                Unlimited SOAP note generation
              </div>
              <div className="flex items-center">
                <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                Advanced AI transcription
              </div>
              <div className="flex items-center">
                <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                Priority support
              </div>
              <div className="flex items-center">
                <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                Export to multiple formats
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col space-y-3 pt-4">
            <Button 
              onClick={() => setShowSubscriptionModal(true)}
              disabled={isLoading}
              className="w-full bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white font-semibold py-3"
            >
              {isLoading ? (
                <div className="flex items-center">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Processing...
                </div>
              ) : (
                <div className="flex items-center justify-center">
                  <CreditCard className="w-4 h-4 mr-2" />
                  Subscribe Now
                  <ArrowRight className="w-4 h-4 ml-2" />
                </div>
              )}
            </Button>
            
            <Button 
              onClick={onViewPricing}
              variant="outline"
              className="w-full border-gray-300 text-gray-700 hover:bg-gray-50"
            >
              View Pricing Plans
            </Button>
          </div>


        </div>
      </DialogContent>
    </Dialog>

    {/* VBot Subscription Modal */}
    <VBotSubscriptionModal
      isOpen={showSubscriptionModal}
      onClose={() => setShowSubscriptionModal(false)}
      onSubscribe={(planType, billingPeriod, seats) => {
        console.log('Selected plan:', { planType, billingPeriod, seats });
        onSubscribe();
        setShowSubscriptionModal(false);
        onClose();
      }}
      onContactSales={goToTalkToSales}
    />
  </>
  );
};

export default TrialExhaustedModal;
